var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBackgroundGroup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 342,
    height: 136,
    viewBox: "0 0 342 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60H116C132.569 60 146 46.5685 146 30C146 13.4315 132.569 0 116 0H30ZM0 106C0 89.4315 13.4315 76 30 76H236C252.569 76 266 89.4315 266 106C266 122.569 252.569 136 236 136H30C13.4315 136 0 122.569 0 106ZM342 106C342 122.569 328.569 136 312 136C295.431 136 282 122.569 282 106C282 89.4315 295.431 76 312 76C328.569 76 342 89.4315 342 106Z",
    fill: "url(#paint0_linear_652_34551)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_652_34551",
    x1: -11.5932,
    y1: 18.6667,
    x2: 246.711,
    y2: 189.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDE4E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.494792,
    stopColor: "#F4F9FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1E7EC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundGroup);
export default __webpack_public_path__ + "static/media/BackgroundGroup.b2a0bc49a7d355cd0bc65206a6fc59f8.svg";
export { ForwardRef as ReactComponent };